/** @type {import('../help-index.js').HelpSidebarItem} */
export const LAB_CAT_CATEGORIES_ITEM = {
  id: 'categories_main',
  screenId: 'lab-cat-categories',
  label: 'Categorías',
  description: 'Convenio, tipo de sueldo y valor básico por categoría.',
  detail: {
    sections: [
      {
        title: 'Para qué sirve',
        intro:
          'Definís las categorías laborales (por ejemplo «Administrativo», «Operario categoría A») con el sueldo básico y reglas de antigüedad. Cada empleado elige una categoría en su legajo y la liquidación usa esos valores.',
      },
      {
        title: 'Lista',
        bullets: [
          'Interruptor «Solo categorías activas» — activo por defecto.',
          'Columnas: ID, Descripción, Tipo sueldo, Valor básico, Activo.',
          'Tocá una fila para ver el detalle; desde ahí podés ir a Editar.',
          'Botón + para alta. Podés exportar.',
        ],
      },
      {
        title: 'Alta de categoría',
        intro: 'Campos del formulario:',
        fields: [
          { label: 'Descripción', description: 'Nombre de la categoría. Obligatoria.' },
          {
            label: 'Tipo de sueldo',
            description: 'Mensual, diario o por hora. Debe coincidir con cómo liquidás (días trabajados, horas, etc.).',
          },
          { label: 'Valor básico', description: 'Importe base de la categoría (≥ 0). Obligatorio.' },
          {
            label: '% Antigüedad (opcional)',
            description: 'Porcentaje por año de antigüedad para esta categoría (ej. 1 = 1% anual). Si el empleado tiene override en su legajo, prevalece el del empleado.',
          },
        ],
        paragraphs: ['Al crear queda activa automáticamente.'],
      },
      {
        title: 'Editar',
        bullets: [
          'Mismos campos que el alta más la casilla Activo.',
          'Desactivá una categoría que ya no uses; los empleados que la tengan asignada conservan el dato histórico.',
        ],
      },
      {
        title: 'Relación con empleados y liquidación',
        paragraphs: [
          'En Laboral → Empleados elegís la categoría de cada trabajador.',
          'Los conceptos con forma de cálculo «Sueldo básico» toman el valor básico de la categoría del empleado.',
        ],
      },
    ],
  },
}
